<div class="info" [ngStyle]="sizeStyle()">
    <span [pTooltip]="info()" class="cursor-pointer" [tooltipPosition]="infoPosition()">
        <i class="bi bi-info-circle-fill"></i>
    </span>
</div>